import { ReactNode } from 'react';
import { formatCurrency } from 'common/services/currency';

import { View } from '@react-pdf/renderer';
import { PDFParagraphBlock } from './index';
import { FondDataFormValues } from '../../models/Forms';
import i18next from 'i18next';
import { I18nNameSpaces } from '../../services/i18n';

interface CellProps {
  value: ReactNode;
  width?: string;
}

const TableCell = ({ value, width = '12.5%' }: CellProps) => (
  <View
    style={{
      width,
      minWidth: 0,
      flexShrink: 0,
      borderRight: '1 solid black',
      borderBottom: '1 solid black',
      justifyContent: 'center',
      padding: 2,
    }}
  >
    <PDFParagraphBlock align="center">{value}</PDFParagraphBlock>
  </View>
);

interface Props {
  data: FondDataFormValues[];
  currency: string;
}

export default function PDFFondTable({ data, currency }: Props) {
  const t = i18next.getFixedT(null, I18nNameSpaces.PDF);
  const cmT = i18next.getFixedT(null, I18nNameSpaces.Common);

  return (
    <>
      <View
        style={{
          border: '1 solid black',
          borderRight: 0,
          flexDirection: 'row',
          flexWrap: 'wrap',
          borderBottom: 0,
        }}
      >
        <View fixed style={{ width: '100%', flexDirection: 'row' }}>
          <TableCell value={cmT('fondTable.columns.code')} width="25%" />
          <TableCell value={cmT('fondTable.columns.buy')} width="8.3%" />
          <TableCell value={cmT('fondTable.columns.sell')} width="8.3%" />
          <TableCell value={cmT('fondTable.columns.hold')} width="8.3%" />
          <TableCell value={`${cmT('fondTable.columns.regularAmount')} ${currency}`} />
          <TableCell value={`${cmT('fondTable.columns.oneTimeAmount')} ${currency}`} />
          <TableCell value={cmT('fondTable.columns.agio')} />
          <TableCell value={cmT('fondTable.columns.note')} />
        </View>
        {data.map((p, i) => (
          <View key={p.key ?? p.code} style={{ width: '100%', flexDirection: 'row' }}>
            <TableCell value={`${i + 1}. ${p.code}`} width="25%" />
            <TableCell value={p.type === 'buy' ? 'x' : '-'} width="8.3%" />
            <TableCell value={p.type === 'sell' ? 'x' : '-'} width="8.3%" />
            <TableCell value={p.type === 'hold' ? 'x' : '-'} width="8.3%" />
            <TableCell value={formatCurrency(p.regularAmount)} />
            <TableCell value={formatCurrency(p.oneTimeAmount)} />
            <TableCell value={p.agio} />
            <TableCell value={p.note || ''} />
          </View>
        ))}
      </View>
      <View
        style={{
          border: '1 solid black',
          padding: 2,
          borderTop: 0,
        }}
      >
        <PDFParagraphBlock lineHeight={1.3}>{t('protocol.section6')}</PDFParagraphBlock>
      </View>
    </>
  );
}
